import { render } from "./ModalLancementJeu.vue?vue&type=template&id=5c080772"
import script from "./ModalLancementJeu.vue?vue&type=script&lang=js"
export * from "./ModalLancementJeu.vue?vue&type=script&lang=js"

import "./ModalLancementJeu.vue?vue&type=style&index=0&id=5c080772&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__